import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-connection-request-failed',
  templateUrl: './connection-request-failed.component.html',
  styleUrls: ['./connection-request-failed.component.scss']
})
export class ConnectionRequestFailedComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }
  @Input() public name;
  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }

}
